import { useState } from "react";

import { useStepContext } from "../../utils/StepContext.jsx"
import { useFormContext } from "../../utils/FormContext.jsx"; 
import { useMediaQuery } from "react-responsive";
import { useAuth } from "../../utils/AuthContext/AuthContext.jsx"

import InfoSVG from '../../assets/InfoSVG.jsx'; 
import MainCard from "../MainCard.jsx";
import ProgressBar from "../ProgressBar/ProgressBar.jsx";
import InfoModal from "../InfoModal.jsx";
import SaveButton from "../SaveButton.jsx";
import PDFPreview from "../PDFPreview.jsx";
import HelpButton from "../HelpButton.jsx";
import ShishitoAssist from "../ShishitoAssist/ShishitoAssist.jsx";

const Prorations = () => {

    const { handleNext, handleBack } = useStepContext();
    const { formData, formId, handleProrationChange, handleClosingServicesFeeInputChange, handleWaterRightsTextChange } = useFormContext(); 
    const [isInfoModalOpen, setIsInfoModalOpen] = useState(false); 
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    const { user } = useAuth();
    const [isAssistVisible, setIsAssistVisible] = useState(false);

    const handleInfoClick = () => {
        setIsInfoModalOpen(true); 
    }; 

    const handleCloseInfoModal = () => {
        setIsInfoModalOpen(false); 
    };

    const toggleAssist = () => {
        setIsAssistVisible(!isAssistVisible);
    };

    const InfoModalContent =
        {
        title: "What's The Difference?",
        content: "If you are asking yourself what is the difference, then fear not. The difference between prorating taxes based on the previous calendar year's taxes and the most recent mill levy and assessment is the inclusion or exclusion of changes in the property's value and the tax rate for the current year.",
        secondHeader: "Which Method Should I Choose?",
        contentTwo: "Generally Speaking if there have been significant changes in the property's assessed value or the tax rate for the current year. You could use the taxes from the previous calendar year if the current year's property taxes have not been assessed yet or when there has been no significant change in the property's assessed value or the mill levy rate for the current year.",
        }; 

    const currentPageValue = 2;
    const currentSubStepProgress = 5/7; 
    
    // console.log(formData);

    const onNext = () => {
        handleNext();
    };

    return (
        <div className="flex flex-col items-center">
        {/* <ProgressBar currentPage={currentPageValue} subStepProgress={currentSubStepProgress}/> */}
        <MainCard width={750}>
            <div className="overflow-y-auto md:max-h-[425px] max-h-[45vh] w-full">
            <div className="inline-flex w-full justify-between mb-8">
            {isMobile ? <h3 className="text-black text-[18px] text-left font-normal font-['Inter']">Prorations</h3> : <h3 className="text-black text-xl text-left font-normal font-['Inter']">Prorations</h3>}
                <div className='h-auto gap-2 md:gap-4 items-center inline-flex'>
                    <HelpButton onClick={toggleAssist}/>
                    <SaveButton formData={formData} formId={formId}/>
                    {user && <PDFPreview formData={formData}/>}
                </div>
            </div>
            
            {/* CLOSING SERVICES FEE */}
            <div className="flex flex-col">
                <div className="flex flex-col justify-between">
                    <div className="w-full inline-flex gap-5 mb-2">
                        <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter]'>Prorate Taxes</span>                
                        <div className="flex flex-row justify-between">
                            <InfoSVG onClick={handleInfoClick}/>
                        </div>
                    </div>
                    <span className="w-full h-auto text-shi-purple mb-3 text-[13px] md:text-xs font-['Inter']">Prorating taxes between buyer and seller involves dividing the property taxes for a given period (usually the year of sale) between the two parties based on their respective ownership periods.</span>
                </div>
                
                <div className="w-full self-stretch justify-start gap-[15px] flex flex-col items-center mb-8">
                    <div className="w-full items-center gap-2 flex">
                        <input 
                            type="radio"
                            id="prorationMillLevy" 
                            value="millLevy" 
                            checked={formData.prorationTaxes === 'millLevy'} 
                            onChange={(e) => handleProrationChange('prorationTaxes', e.target.value)}
                            
                        />
                        <div className="flex flex-col justify-between w-full">
                            <label className="text-slate-600 font-['Inter'] w-full flex-wrap">Most Recent Mill Levy and Assessed Valuation</label>
                            <span className="h-auto text-shi-purple mb-3 text-xs font-['Inter'] flex-wrap">Considers the assessed value of the property and the mill levy rate in the current year to calculate the tax amount.</span>
                        </div>
                    </div>
                    <div className="w-full items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="taxesPrecedingYear"
                            value="prorateTaxesPrecedingYear" 
                            checked={formData.prorationTaxes === 'prorateTaxesPrecedingYear'} 
                            onChange={(e) => handleProrationChange('prorationTaxes', e.target.value)}
                        />
                    <div className="flex flex-col justify-between">
                        <label className="text-slate-600 font-['Inter'] w-full">Taxes for Calendar Year Preceding Close</label>
                        <span className="w-full h-auto text-shi-purple mb-3 text-xs font-['Inter']">This method is often used when the current year's taxes have not been assessed yet.</span>
                    </div>
                    </div>
                    <div className="items-center gap-2 flex w-full text-left">
                        <input 
                            type="radio" 
                            id="prorateOther"
                            value="prorateOther" 
                            checked={formData.prorationTaxes === 'prorateOther'} 
                            onChange={(e) => handleProrationChange('prorationTaxes', e.target.value)}
                        />
                        <label className="text-slate-600 font-['Inter']">Other (N/A)</label>
                        <div className="items-center gap-2 flex">
                        <input 
                                type="text"
                                name="prorationTaxesOtherText"
                                className="w-full py-1 px-3 h-[39px] self-stretch text-left bg-white rounded-md border border-slate-300 justify-start items-center gap-2.5 flex"
                                placeholder="Other Input"
                                value={formData.prorationTaxesOtherText}
                                onChange={handleClosingServicesFeeInputChange}
                        />
                        </div>
                    </div>
                </div>

                {/* RENTS */}
                <div className="flex flex-col justify-between">
                    <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter]'>Rents</span>
                    <span className="w- h-auto text-shi-purple mb-2 text-xs font-['Inter']">What Seller will pay if there are rents on the property</span>
                </div>
                
                <div className="w-full self-stretch justify-start gap-[15px] flex flex-col items-center mb-8">
                    <div className="w-full items-center gap-2 flex">
                        <input 
                            type="radio"
                            id="rentsTypeActuallyRecieved" 
                            value="rentsTypeActuallyReceived" 
                            checked={formData.rentsType === 'rentsTypeActuallyReceived'} 
                            onChange={(e) => handleProrationChange('rentsType', e.target.value)}
                        />
                        <div className="flex flex-col justify-between">
                            <label className="text-slate-600 font-['Inter'] w-full">Rents Actually Received</label>
                            <span className="w-full h-auto text-shi-purple mb-1.5 text-xs font-['Inter']">Rents that are actually received on the property</span>
                        </div>
                    </div>
                    <div className="w-full items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="rentsTypeAccrued"
                            value="rentsTypeAccrued" 
                            checked={formData.rentsType === 'rentsTypeAccrued'} 
                            onChange={(e) => handleProrationChange('rentsType', e.target.value)}
                        />
                        <div className="flex flex-col justify-between">
                            <label className="text-slate-600 font-['Inter'] w-full">Rents Accrued</label>
                            <span className="w-full h-auto text-shi-purple text-xs font-['Inter']">Rents Accrued on the property</span>
                        </div>
                    </div>
                </div>

                <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter]'>Other Prorations</span>
                <textarea 
                    name="otherProrations"
                    className="w-full bg-slate-100 p-1.5 mb-8" 
                    onChange={handleWaterRightsTextChange}
                    value={formData.otherProrations}
                />

            <div className="flex flex-col">
                <div className="flex flex-col justify-between">
                    <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter]'>Association Assessments</span>    
                    <span className="w-full h-auto text-shi-purple mb-2 text-xs font-['Inter']"></span>
                </div>
                <div className="flex flex-col">
                <div className="inline-flex">
                <div className="self-stretch justify-start gap-[25px] inline-flex items-center mb-5">
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio"
                            id="associationsAssessmentsBuyer" 
                            value="buyer" 
                            checked={formData.associationsAssessments === 'buyer'} 
                            onChange={(e) => handleProrationChange('associationsAssessments', e.target.value)}
                            
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Buyer</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="associationsAssessmentsSeller"
                            value="seller" 
                            checked={formData.associationsAssessments === 'seller'} 
                            onChange={(e) => handleProrationChange('associationsAssessments', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Seller</label>
                    </div>
                    </div>
                    </div>
                        <span className="text-sm text-slate-600">Other Association Assessments</span>
                        <div className="items-center gap-2 flex">
                            <input 
                                    type="text"
                                    name="associationAssessmentsText"
                                    className="w-full py-1 px-3 h-[39px] self-stretch text-left bg-white rounded-md border border-slate-300 justify-start items-center gap-2.5 flex"
                                    placeholder="Other Input"
                                    value={formData.associationAssessmentsText}
                                    onChange={handleClosingServicesFeeInputChange}
                            />
                        </div>
                </div>
            </div>
                {/* <span className="text-black font-[Inter]">Water Rights will be conveyed by a <input type="text" onChange={handleWaterRightsTextChange} value={formData.typeOfDeed} name="typeOfDeed" className="mt-2 h-auto rounded-sm border border-black w-[100px]"/> deed at closing</span> */}
            </div>
        </div>

            {/* BOTTOM BUTTONS */}
          
            <div className="flex w-full justify-center gap-10 md:gap-36 mt-2 bg-white">
                <button className="w-[100px] md:w-[150px] justify-center text-center text-shi-green bg-white border-white text-[16px] md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-slate-200 items-center md:items-start flex" onClick={handleBack}>
                    Back
                </button>
                <button className="w-[100px] md:w-[150px] justify-center items-center text-center text-white bg-shi-green text-[16px] md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-green-950 md:items-start flex" onClick={onNext}>
                    Next
                </button>
            </div>
        </MainCard>
        {isAssistVisible && (
                <div className="w-full md:w-auto absolute bottom-1 md:right-4">
                    <ShishitoAssist onClose={toggleAssist}/>
                </div>
            )}

        <InfoModal isOpen={isInfoModalOpen} onClose={handleCloseInfoModal}>
                <div>
                    <h1 className="text-shi-green text-2xl font-bold mb-4">{InfoModalContent.title}</h1>
                    <hr className="my-4" />
                    <p className="text-base">{InfoModalContent.content}</p>
                    
                    <h1 className="text-shi-green text-2xl font-bold my-4">{InfoModalContent.secondHeader}</h1>
                    <hr className="my-4" />
                    <p className="text-base">{InfoModalContent.contentTwo}</p>
                </div>
        </InfoModal>
        </div>
        
    )
}

export default Prorations; 